<template>
  <div class="home">
    <button @click="changeLan" style="background:deepskyblue;border:none;color:#fff;height:60px;position:fixed;left:0;top:0;display:none">{{$t("switchLan")}}</button>
    <h1 id="brand">phynz</h1>
    <div class="banner">
      <img src="../common/imgs/banner.png" alt="phynz">
    </div>
    <div class="title">
      <img src="../common/imgs/title.png" alt="phynz.com即将到来">
    </div>
    <main>
      <div class="main-container">
        <h3>风石科技的使命是用场景化和游戏化铺就复杂科学的学习道路，让游戏多一点想象。</h3>
        <h2>用场景认知世界。</h2>
        <h3>目前，风石科技已经深度参与到供应链管理学科中来，引入了国家著名的严肃游戏，联合教练、国内知名供应链管理学科讲师、大学教授等，开展基于严肃游戏的供应链
          体验、培训和学习。客户涵盖国内一流大学、国际500强企业等，也面向行业从业者个人开放供应链大赛、公开课和线上课程。</h3>
          <button>
            <a href="http://www.thefreshconnection.com.cn/" target="_blank">
              <span>2018卓越供应链大赛官网</span>
              <span class="tr"></span>
            </a>
          </button>
      </div>
    </main>
    <footer>
      <div class="about">
        <div class="follow-us about-item">
          <span class="follow">关注我们</span>
          <div class="qr">
            <div class="qr-code">
              <img src="../common/imgs/QR_code.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="join-us about-item">
          <span class="join">
            <a href="https://mp.weixin.qq.com/s?__biz=MzUzNzQ2OTUzNA==&mid=100000421&idx=1&sn=6aa8875199ff3939e64f952088d19333&chksm=7ae735944d90bc82dafeee230b65a097661fa9589c30819e3ccddcf908d7282848f75700b5c0&scene=18#wechat_redirect" target="_blank">加入我们</a>
          </span>
        </div>
      </div>
      <div class="cp">
        <p>&copy; 2018 风石科技 <a href="http://www.miitbeian.gov.cn/" target="_blank">沪ICP备17047852号</a></p>
        <p>沪公网安备31010502002794号</p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'Home',
  methods: {
    changeLan() {
      const language = this.$ck.getCookie('language')
      if (language === 'zh') {
        this.$ck.setCookie('language', 'en')
        this.$i18n.locale = 'en'
      } else {
        this.$ck.setCookie('language', 'zh')
        this.$i18n.locale = 'zh'
      }
    }
  }
}
</script>
<style lang="less" scoped>
a:link,a:active,a:visited {
  color: rgb(160, 160, 160);
}

#brand {
  height: 0;
  width: 0;
  overflow: hidden;
  margin: 0;
}

.banner {
  img {
    width: 100%;
  }
}

.title {
  text-align: center;
  padding-top: 90px;
  padding-bottom: 38px;
  img{
    width: 48%;
  }
}

main {
  margin-bottom: 80px;
   .main-container {
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h2 {
    color: rgb(83, 83, 83);
    margin: 10px 0 48px;
    font-weight: 400;
    font-size: 36px;
  }
   h3 {
    font-size: 14px;
    font-weight: normal;
    text-align: center;
  }
  button {
    background: #fff;
    height: 80px;
    width: 340px;
    border: 1.3px solid rgba(128, 128, 128, 0.226);
    border-radius: 100px;
    margin-top: 30px;
    outline: none;
    a {
      height: 100%;
      letter-spacing: .5px;
      color: rgb(160, 160, 160);
      width: 100%;
      display: block;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 30px 0 30px;
      box-sizing: border-box;
      &:link,a:active,a:visited {
        color: rgb(160, 160, 160);
      }
      span {
        color: rgb(160, 160, 160);
        display: inline;
      }
    }
  }
  .tr {
    background-image: url('../common/imgs/tr.png');
    height: 16px;
    width: 16px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin-left: 20px;
  }
}

footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  padding: 0 0 40px 0;
  .about {
    color: #4564BA;
    margin-bottom: 20px;
    a:link,a:active,a:visited {
      color: #4564BA;
    }
    .about-item {
      padding: 2px 4px;
      display: inline-block;
      .follow {
        cursor: pointer;
        &:hover+.qr {
          display: block;
        }
      }
    }
    .qr {
      height: 120px;
      width: 120px;
      padding: 10px;
      position: absolute;
      background: #fff;
      margin-top: -180px;
      margin-left: -40px;
      box-shadow: 0 0 10px rgba(128, 128, 128, 0.247);
      z-index: 2;
      display: none;
      img {
        width: 100%;
      }
      &::after {
        content: '';
        display: block;
        height: 10px;
        width: 10px;
        position: absolute;
        transform: rotateZ(45deg);
        background: #fff;
        z-index: 1;
        margin-top: 4px;
        margin-left: 54px;
        box-shadow: 3px 2px 0px rgba(216, 216, 216, 0.233);
      }
    }
  }
  .cp {
    font-size: 13px;
    text-align: center;
    p {
      margin: 0;
    }
  }
}

@media only screen and (max-width:430px){
  main .main-container button {
    width: 90%;
    height: 70px;
  }
  main .main-container button .tr {
    display: none;
  }
  .title {
    padding-top: 60px;
  }
  .title img {
    width: 80%;
  }
  main h2 {
    font-size: 28px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue